/* eslint-disable @typescript-eslint/consistent-type-assertions */
/* eslint-disable arrow-body-style */
import React, {
  useEffect,
  useMemo,
  useRef,
  useState,
  Dispatch,
  SetStateAction,
} from 'react';
import classnames from 'classnames';
import SvgIcon from '@/pages/home/components/SvgIcon';
import { Bubble, Menu } from 'tea-component';
import { useLocation, history, getLocale, useIntl } from 'umi';
import {
  parseCommonUrlInfo,
  getPathWithoutSearchParams,
} from '@/pages/home/components/LeftMenu/_utils';
import {
  IMenuItemType,
  OpenedChangeMenuType,
} from '@/pages/home/components/LeftMenu/type';
import { ENV, LANGUAGE_EN } from '@/pages/home/_config/config';
import NewMarkIcon from '@home/components/NewMarkIcon';
import CommonBubble from '@home/components/CommonBubble';
import FavoriteProject from './components/FavoriteProject';
import OnClickBtnItem from './components/OnClickBtnItem';
import MenuItemComp from './components/MenuItemComp';
import './index.scss';
import { isEmpty } from 'lodash-es';
import { isSafari } from '@gp/utils/common';
import { getBasePath } from '@/utils/utils';
import { GPOP_BEGINNER_GUIDE_DOC_URL } from '@gp/constants/const';

// 受控的环境，预发布和正式
const controlledEnv = ['pre', 'pro'];
const isControlled = controlledEnv.includes(ENV);
export interface IMenuListWrapPropsType {
  menuList: Array<IMenuItemType>;
  isNormal: boolean;
  clickMenu?: Function;
  setNormal: Dispatch<SetStateAction<boolean>>;
  isHyperlink?: boolean; // 菜单栏跳转项是否需要超链接
  currentPath?: string;
  onSet?: string;
  isShowShrinkMenuTextBubble?: boolean; // 菜单栏最小展示时，是否hover菜单icon展示text
}

export default function GPCustomMenu(props: IMenuListWrapPropsType) {
  const {
    isNormal,
    menuList,
    clickMenu,
    isHyperlink = false,
    currentPath,
    isShowShrinkMenuTextBubble = false,
    onSet,
  } = props;

  const selectedMenuRef = useRef<IMenuItemType | null>(null);
  const selectedMainMenuRef = useRef<IMenuItemType | null>(null);
  // 父父级菜单
  const selectedGrandMenuRef = useRef<IMenuItemType | null>(null);
  const [selectedFavProItem, setSelectedFavProItem] = useState({});
  const location = useLocation();
  const [bubbleInfo, setBubbleInfo] = useState<null | {
    ele: HTMLLIElement;
    menu: any;
  }>(null);
  // 当前折叠的菜单
  const [openedChangeMenuCur, setOpenedChangeMenuCur] =
    useState<OpenedChangeMenuType>({
      menuId: '',
      opened: false,
    });
  useIntl();
  const isEn = getLocale() === LANGUAGE_EN;

  const setNormal = (value: any) => {
    onSet?.(!value);
  };

  const handleChangeMenu = (menu: IMenuItemType, menuPa: IMenuItemType) => {
    const { system } = parseCommonUrlInfo(location.pathname);
    // if (selectedMenuRef.current?.id === menu.id) {
    //   return;
    // }
    setSelectedFavProItem({});
    if (clickMenu instanceof Function) {
      // 如果 clickMenu 返回 false，直接返回以中止后续代码执行
      if (clickMenu(menu, menuPa) === false) {
        return;
      }
    }
    // 记录点击的menu
    selectedMenuRef.current = menu;
    selectedMainMenuRef.current = menuPa;
    // 修改路由
    history.push(`/${system}/${menu.path || ''}`);
  };

  // 递归筛选可显示的菜单
  const getFilterMenuList = (menuList: IMenuItemType[]) => {
    const filterMenuListNew: IMenuItemType[] = [];
    menuList?.forEach((menu) => {
      const { env = [], subMenus = [] } = menu;
      if (isControlled && !env.includes(ENV)) {
        return;
      }
      const filterSubMenus = subMenus.filter((subMenu) => {
        const { env = [] } = subMenu;
        return !isControlled || env.includes(ENV);
      });
      filterMenuListNew.push({
        ...menu,
        subMenus: getFilterMenuList(filterSubMenus),
      });
    });
    return filterMenuListNew;
  };

  // 筛选可显示的菜单
  const filterMenuList = useMemo((): IMenuItemType[] => {
    return getFilterMenuList(menuList);
  }, [menuList]);

  // 递归赋值系统语言文本
  const getFormatMenuList = (menuList: IMenuItemType[]): IMenuItemType[] => {
    if (!Array.isArray(menuList)) return menuList;
    return menuList?.map((item: IMenuItemType) => {
      const { title, titleCN = '' } = item;
      const itemTemp = {
        ...item,
        text: isEn ? title : titleCN || title,
      };
      if (
        item.subMenus &&
        Array.isArray(item.subMenus) &&
        item.subMenus.length > 0
      ) {
        return {
          ...itemTemp,
          subMenus: getFormatMenuList(item.subMenus),
        };
      }
      return itemTemp;
    });
  };
  // 独立管理每个菜单项的 showDelete 状态，使用 menu.id 作为 key
  const [showDeleteMap, setShowDeleteMap] = useState<Record<string, boolean>>({});
  // 切换语言
  const formatMenuListCur: IMenuItemType[] = useMemo((): IMenuItemType[] => {
    return getFormatMenuList(filterMenuList);
  }, [isEn, filterMenuList]);

  useMemo(() => {
    // todo menuList 变化，重置选择项
    selectedMenuRef.current = null;
    selectedMainMenuRef.current = null;
    selectedGrandMenuRef.current = null;
  }, [filterMenuList]);

  // 根据路由确认左侧菜单是否选中
  useMemo(() => {
    const { pathname, state = {} as any } = location;
    let { realPath } = parseCommonUrlInfo(pathname);
    if (currentPath) {
      realPath = currentPath;
    }

    if (!realPath) {
      return;
    }
    // todo 如果路径相同，直接返回
    if (realPath === selectedMenuRef.current?.path) {
      return;
    }

    // todo 处理点击下钻页，左侧菜单保持前一个状态
    if (selectedMenuRef.current && state?.noMatch === true) {
      return;
    }

    filterMenuList.some((menu) => {
      if (menu.subMenus?.length) {
        return menu.subMenus.some((subMenu) => {
          // 三级菜单特殊逻辑，如果浏览器刷新时，选中的是第三级菜单，需要添加三个菜单选中状态
          if (subMenu?.subMenus?.length) {
            return subMenu?.subMenus?.some((sunMenu) => {
              if (
                sunMenu.path &&
                realPath.startsWith(getPathWithoutSearchParams(sunMenu.path))
              ) {
                selectedMenuRef.current = sunMenu;
                selectedMainMenuRef.current = subMenu;
                selectedGrandMenuRef.current = menu;
                return true;
              }
              return false;
            });
          }

          if (
            subMenu.path &&
            realPath.startsWith(getPathWithoutSearchParams(subMenu.path))
          ) {
            selectedMenuRef.current = subMenu;
            selectedMainMenuRef.current = menu;
            return true;
          }
          return false;
        });
      }

      if (
        menu.path &&
        realPath.startsWith(getPathWithoutSearchParams(menu.path))
      ) {
        selectedMenuRef.current = menu;
        selectedMainMenuRef.current = menu;
        return true;
      }
      return false;
    });
  }, [location, currentPath, filterMenuList]);

  // 菜单位置定位
  useEffect(() => {
    let { realPath } = parseCommonUrlInfo(location.pathname);
    if (currentPath) {
      realPath = currentPath;
    }
    if (!realPath || !selectedMenuRef.current) {
      return;
    }

    const $menuList: HTMLCollectionOf<Element> =
      document.getElementsByClassName(
        `js-menu-common-${selectedMenuRef.current.id}`,
      );
    if ($menuList.length < 1) {
      return;
    }

    // 检查当前菜单是否在视野范围内
    const inWindow = [...$menuList].some((item): boolean => {
      const rectObject = item.getBoundingClientRect();
      const bottomHeight = 42; // 菜单区域下边界与底部的距离
      const topHeight = 50; // 菜单区域上边界与顶部的距离
      const selfHalfHeight = 18; // 一个菜单项的半高
      const parentElement = item?.parentElement?.parentElement;
      if (item.classList.contains('menu-context-primary')) {
        if (
          rectObject?.top <=
            window.innerHeight - bottomHeight - selfHalfHeight &&
          rectObject?.bottom >= topHeight + selfHalfHeight
        ) {
          return true;
        }
        return false;
      }
      // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
      if (
        parentElement &&
        parentElement.classList.contains('is-expanded') &&
        rectObject?.top <= window.innerHeight - bottomHeight - selfHalfHeight &&
        rectObject?.bottom >= topHeight + selfHalfHeight
      ) {
        return true;
      }
      return false;
    });

    // 不在视野的情况下，滚动到视野中
    if (!inWindow) {
      const $parentElement = $menuList[0]?.parentElement?.parentElement;
      if ($parentElement && !$parentElement.classList.contains('is-expanded')) {
        // @ts-ignore
        $parentElement?.childNodes?.[0].click(); // 模拟点击
      }

      // 三级菜单特殊逻辑，如果有父父级菜单，则要同时打开父父级菜单
      if (selectedGrandMenuRef.current && selectedMainMenuRef.current) {
        const $menuGrandList: HTMLCollectionOf<Element> =
          document.getElementsByClassName(
            `js-menu-common-submenu-${selectedMainMenuRef.current.id}`,
          );
        if ($menuGrandList) {
          const $parentGrandElement =
            $menuGrandList[0]?.parentElement?.parentElement;
          if (
            $parentGrandElement &&
            !$parentGrandElement.classList.contains('is-expanded')
          ) {
            // @ts-ignore
            $parentGrandElement?.childNodes?.[0].click(); // 模拟点击
          }
        }
      }

      // 强制异步执行
      setTimeout(() => {
        $menuList[0]?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 10);
    }
  }, [location, menuList, currentPath]);

  // 三级菜单特殊逻辑，如果当前选中的是第三级菜单，当折叠当前一级菜单时，要选中高亮
  const isSelectedSubMenuCur = useMemo(() => {
    if (
      openedChangeMenuCur?.menuId &&
      !openedChangeMenuCur?.opened &&
      selectedMainMenuRef.current
    ) {
      if (
        openedChangeMenuCur?.menuId ===
        selectedMainMenuRef.current?.parentMenuId
      ) {
        return true;
      }
      return false;
    }
    return false;
  }, [openedChangeMenuCur]);

  const handleOpenLink = (url: string) => {
    if (!url) return;
    if (isSafari()) {
      const page = window.open('', '_blank');
      if (page) {
        page.location = url;
      }
    } else {
      window.open(url, '_blank');
    }
  };

  // 多层菜单级联
  const renderMenuFun = (
    menuItemList: IMenuItemType[],
    menuPa: IMenuItemType,
    isFirstMenu = false,
  ) => {
    return (
      <>
        {menuItemList?.map((menu: any) => {
          if (menu?.page_id === 'favorite_project') {
            return (
              <FavoriteProject
                isHyperlink={isHyperlink}
                selectedFavProItem={selectedFavProItem}
                setSelectedFavProItem={setSelectedFavProItem}
                key={menu.id}
              />
            );
          }
          if (menu?.type === 'onclickBtn') {
            let url = '';

            if (menu?.page_id === 'user_guide') {
              url = GPOP_BEGINNER_GUIDE_DOC_URL;
            } else {
              const basePath = getBasePath();
              const { protocol, host } = window.location;
              url = `${protocol}//${host}${basePath}/g-pop${menu?.assembly_url}`;
            }
            const classNameCur = isFirstMenu
              ? classnames('menu-context-primary', menuPa?.className)
              : menu?.className;

            const handleMouseLeave = () => {
              setBubbleInfo(null);
              setShowDeleteMap((prev) => ({
                ...prev,
                [menu.id]: false,
              }));
            };
            const handleMouseEnter = () => {
              setBubbleInfo(null);
              setShowDeleteMap((prev) => ({
                ...prev,
                [menu.id]: true,
              }));
            };

            return (
              <Menu.Item
                key={menu.id}
                // @ts-ignore
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                selected={
                  selectedMenuRef.current?.id === menu.id
                    ? isEmpty(selectedFavProItem)
                    : false
                }
                onClick={() => {
                  handleOpenLink(url);
                }}
                className={`js-menu-common-${menu.id} ${classNameCur || ''}`}
                title={
                  <OnClickBtnItem
                    key={menu.id}
                    data={menu}
                    url={url}
                    showDelete={showDeleteMap[menu.id]}
                  />
                }
                icon={
                  <SvgIcon
                    className="left-nav-icon"
                    type={menu.icon || 'default'}
                  />
                }
              />
            );
          }
          if (menu?.subMenus && menu?.subMenus?.length > 0) {
            return (
              <Menu.SubMenu
                defaultOpened={menu.defaultOpened}
                onOpenedChange={(opened) => {
                  setOpenedChangeMenuCur({
                    menuId: menu.id,
                    opened,
                  });
                }}
                key={menu.id}
                className={classnames(
                  menu?.className,
                  `js-menu-common-submenu-${menu.id}`,
                  {
                    'left-nav-third-level-menu': !isFirstMenu,
                    'is-selected':
                      menu.id === openedChangeMenuCur?.menuId &&
                      isSelectedSubMenuCur &&
                      isEmpty(selectedFavProItem),
                  },
                )}
                icon={
                  menu?.isLocalIcon ? (
                    <img
                      className="dbh-menu-local-icon"
                      src={menu?.localIcon}
                      alt=""
                    />
                  ) : (
                    <SvgIcon
                      className="left-nav-icon"
                      type={menu.icon || 'default'}
                    />
                  )
                }
                title={
                  <div className="left-nav-hd">
                    <span className="menu-context-text">{menu.text}</span>
                    {menu?.showNew && (
                      <NewMarkIcon
                        className={`left-nav-notice db-parent-menu-new ${
                          menu?.newMarkType === 1 ? 'dbh-beta-tag' : ''
                        }`}
                        type={menu?.newMarkType}
                      />
                    )}
                  </div>
                }
              >
                {renderMenuFun(menu.subMenus, menu)}
              </Menu.SubMenu>
            );
          }
          return (
            <MenuItemComp
              key={menu.id}
              className={
                isFirstMenu
                  ? classnames('menu-context-primary', menuPa?.className)
                  : menu?.className
              }
              menu={menu}
              menuPa={menuPa}
              onClick={handleChangeMenu}
              selected={
                selectedMenuRef.current?.id === menu.id
                  ? isEmpty(selectedFavProItem)
                  : false
              }
              isHyperlink={isHyperlink}
              setBubbleInfo={setBubbleInfo}
            />
          );
        })}
      </>
    );
  };

  return (
    <>
      <div className="navmenu-bd dbg-favorite-projects">
        {isNormal ? (
          <>
            <Menu className="menu-context">
              {renderMenuFun(formatMenuListCur, formatMenuListCur, true)}
            </Menu>
          </>
        ) : (
          <div className="width-item">
            <div className="width-item-line"></div>
            {formatMenuListCur?.map((menu: any, index: any) => (
              <CommonBubble
                content={isShowShrinkMenuTextBubble ? menu.text : null}
                placement="right"
                key={index}
                dark
              >
                <div
                  key={menu.id}
                  className={`width-item-icon ${
                    selectedMainMenuRef.current?.id === menu.id
                      ? 'width-item-action'
                      : ''
                  }`}
                  onClick={() => {
                    setNormal(true);
                  }}
                >
                  <SvgIcon type={menu.icon || 'default'} />
                </div>
              </CommonBubble>
            ))}
          </div>
        )}
        {bubbleInfo && (
          <Bubble
            visible={true}
            dark
            placement="right"
            referenceElement={bubbleInfo.ele}
            content={bubbleInfo.menu?.text}
          />
        )}
      </div>
    </>
  );
}
